module.exports = __webpack_public_path__ + "img/1561912230.351c8d92.jpg";